<template>
  <div id="HomePage">
    <!-- <md-toolbar class="md-primary"> -->
      <!-- <span class="md-title">My Title</span> -->
      <Header/>

      <!-- <div class="md-toolbar-section-end"> -->
        <md-button @click="showSidepanel = true">
          <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-list" fill="currentColor" xmlns="http://www.w3.org/2000/svg" style="color: white; font-size: 35px;">
          <path fill-rule="evenodd" d="M2.5 11.5A.5.5 0 0 1 3 11h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4A.5.5 0 0 1 3 7h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4A.5.5 0 0 1 3 3h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z"/>
        </svg>
        </md-button>
      <!-- </div> -->
    <!-- </md-toolbar> -->
    <md-drawer class="md-right" :md-active.sync="showSidepanel">
      <md-list>
        <md-list-item>
          <button class="btn" @click="clear_clusters(), showSidepanel = false">{{$t('message.new')}}</button>
        </md-list-item>
        <md-list-item>
          <button class="btn" @click="save_file">{{$t('message.save')}}</button>
        </md-list-item>
        <md-list-item>
        <div class="upload-btn-wrapper">
          <button class="btn">{{$t('message.open')}}</button>
          <input type="file" name="myfile" @change="onFileChange" accept='application/json'>
        </div>
        </md-list-item>

        <div class='linia'><span></span></div>

        <md-list-item>
          <button class="btn" @click="showDialogInfoProgram = !showDialogInfoProgram, showSidepanel = false">{{$t('message.about_program')}}</button>
        </md-list-item>
        <md-list-item>
          <button class="btn" onclick="window.open('https://www.pulsar.pl/PL_884_dokumenty-dso-pra', '_blank');">{{$t('message.documentations')}}</button>
        </md-list-item>

        <div class='linia'><span></span></div>

        <md-list-item>
          <button class="btn" @click="showDialogDaneAdresowe = !showDialogDaneAdresowe, showSidepanel = false">{{$t('message.address')}}</button>
        </md-list-item>

        <div class='linia'><span></span></div>

        <md-list-item>
          <button class="btn" @click="showDialogPodsumowanie = !showDialogPodsumowanie, showSidepanel = false">{{$t('message.results')}}</button>
        </md-list-item>
      </md-list>
      <!-- <md-list>
        <md-list-item>
          <button class="btn" onclick="window.open('https://www.pulsar.pl/PL_848_dokumenty', '_blank');">Dokumentacja</button>
        </md-list-item>
        <md-list-item>
          <button class="btn" @click="showDialogDaneAdresowe = !showDialogDaneAdresowe, showSidepanel = false">Dane adresowe</button>
        </md-list-item>
        <md-list-item>
          <button class="btn" @click="showDialogZapytanie = !showDialogZapytanie, showSidepanel = false">Wyślij zapytanie</button>
        </md-list-item>
      </md-list> -->
    </md-drawer>

    <md-content>
      <Content/>
    </md-content>

    <Podsumowanie
      :showDialog="showDialogPodsumowanie"
      @clickedClose="closedDialog"
    />
    <InfoProgram
      :showDialog="showDialogInfoProgram"
      @clickedClose="closedDialog"
    />
    <DaneAdresowe
      :showDialog="showDialogDaneAdresowe"
      @clickedClose="closedDialog"
    />
<!--
    <Zapytanie
      :showDialog="showDialogZapytanie"
      @clickedClose="closedDialog"
    /> -->

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { app } from '../mixins/app'
import { materials } from '../mixins/materials'
import { calculation } from '../mixins/calculation'

import Content from './Content'
import Header from './Header'
import Podsumowanie from './Dialogs/Podsumowanie.vue'
import InfoProgram from './Dialogs/InfoProgram'
import DaneAdresowe from './Dialogs/DaneAdresowe'
// import Zapytanie from './Dialogs/Zapytanie'

export default {
  name: 'Temporary',
  mixins: [app, materials, calculation, InfoProgram],
  data: () => ({
    fileOpen: {},
    showSidepanel: false,
    showDialogPodsumowanie: false,
    showDialogInfoProgram: false,
    showDialogDaneAdresowe: false,
    showDialogZapytanie: false
  }),
  components: {
    Header, Content, Podsumowanie, InfoProgram, DaneAdresowe
    //, Zapytanie
  },
  computed: {
    ...mapGetters('app', ['config']),
    ...mapGetters('app', ['inputs']),
    ...mapGetters('app', ['outputs']),
    ...mapGetters('app', ['clusterOne']),
    ...mapGetters('app', ['clusterTwo']),
    ...mapGetters('app', ['clusterThree']),
    ...mapGetters('app', ['clusterFour']),
    ...mapGetters('app', ['clusterFive']),
    ...mapGetters('app', ['clusterSix']),
    ...mapGetters('products', ['ListaSzafy']),
    ...mapGetters('products', ['ListaBosch']),
    ...mapGetters('products', ['ListaPulsar']),
    ...mapGetters('products', ['ListaAkumulatory']),
    ...mapGetters('products', ['ListaMaterialy'])
  },
  methods: {
    closedDialog (bool) {
      this.showDialogInfoProgram = bool
      this.showDialogDaneAdresowe = bool
      this.showDialogZapytanie = bool
      this.showDialogPodsumowanie = bool
    },
    save_file () {
      var json = {
        'config': this.config,
        'inputs': this.inputs,
        'outputs': this.outputs,
        'clusterOne': this.clusterOne,
        'clusterTwo': this.clusterTwo,
        'clusterThree': this.clusterThree,
        'clusterFour': this.clusterFour,
        'clusterFive': this.clusterFive,
        'clusterSix': this.clusterSix
      }
      const data = JSON.stringify(json)
      var dzis = new Date().toLocaleDateString()
      var FileSaver = require('file-saver')
      var blob = new Blob([data], {type: 'application/json;charset=utf-8'})
      FileSaver.saveAs(blob, dzis + '_' + this.outputs.keyGen.value.replaceAll('-', '_') + '.json')
      self.showSidepanel = false
    },
    onFileChange (e) {
      const file = e.target.files[0]
      const reader = new FileReader()
      var self = this
      reader.onload = (function (f) {
        return function (e) {
          self.fileOpen = JSON.parse(e.target.result)
          self.showSidepanel = false
          self.change_value_state(self.fileOpen)
        }
      })(file)
      reader.readAsText(file)
    },
    change_value_state (items) {
      // if (Object.keys(items.rabat).length > 0) {
      //   this.changeValueOutputs('rabat', 'value', items.rabat.value)
      // }
      // console.log(items.outputs.szafa)
      if (Object.keys(items).length > 0) {
        var keysList = ['config', 'inputs', 'outputs', 'clusterOne', 'clusterTwo', 'clusterThree', 'clusterFour', 'clusterFive', 'clusterSix']
        var count = 0
        Object.keys(items).forEach(element => {
          if (keysList.indexOf(element) > -1) {
            count++
          }
        })
        if (count === keysList.length) {
          console.log('wczytanie pliku')
          this.$store.commit('app/UPDATE_DATA_FILE', items)
          this.$store.commit('app/UPDATE_VARIABLES', {'name': 'openFile', 'value': true})
          // console.log(items.outputs)
          // console.log(items.outputs.szafa_zajete_miejsce.value)
          this.obliczenia_sprzetowe(true)
          // this.changeRackCabinets(items.outputs.szafa_zajete_miejsce.value)
        } else {
          console.log('problem z plikiem, zła wersja pliku')
          alert('Problem! Zły plik lub wersja pliku')
        }
        //   var page = ''
        //   switch (element) {
        //     case 'clusterOne': page = 'cluster1'
        //       break
        //     case 'clusterTwo': page = 'cluster2'
        //       break
        //     case 'clusterThree': page = 'cluster3'
        //       break
        //     case 'clusterFour': page = 'cluster4'
        //       break
        //     case 'clusterFive': page = 'cluster5'
        //       break
        //     case 'clusterSix': page = 'cluster6'
        //       break
        //     // eslint-disable-next-line no-unused-expressions
        //     default: ''
        //   }

        //   // this.$store.commit('app/UPDATED_CLUSTER', [page, items[element]])
        //   // if (items[element].value !== 0) {
        //   //   this.changeValueInputs(element, 'value', items[element].value)
        //   // }
        // })
      }
      // console.log(items.rabat)
    }
  }
}
</script>

<style scoped>
#HomePage {
  background: #efefef;
  overflow: hidden;
}
button.md-button {
  position: absolute;
  top: 15px;
  right: 5px;
}
#HomePage .md-drawer {
  width: 215px;
  background: #0c3351 !important;
}
#HomePage .md-list {
  background: #0c3351 !important;
}
#HomePage .md-list li:hover{
  background: #061f33 !important;
  margin: 0px 0px;
}
#HomePage .md-list li:hover button{
  color: #07b9ff;
}

.upload-btn-wrapper {
  position: relative;
  overflow: hidden;
  display: inline-block;
  border: 0px solid gray;
  border-radius: 0px;
}

.btn {
  color: gray;
  background: none;
  padding: 2px 4px;
  font-size: 15px;
  font-weight: bold;
  color:#fff;
  font-weight: normal;
}

.upload-btn-wrapper input[type=file] {
  font-size: 23px;
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
  cursor: pointer;
}
.linia {
  width:100%
}
.linia span {
border-bottom: #0b4877 2px solid;
height: 1px;
display: block;
width: 165px;
margin: 0px auto;
}
</style>



// WEBPACK FOOTER //
// src/components/HomePage.vue